const sidebar = {
  section: {
    control: '관제',
    admin: '관리',
  },
  myPage: '마이페이지',
  collapse: '메뉴 접기',
  expand: '메뉴 펼치기',
  enterprise: {
    title: '전사 모니터링',
    dashboard: '전사 통합 대시보드',
    factoryOverview: '공장별 사출 현황',
    dataflow: '데이터 수집 흐름',
  },
  factory: {
    title: '공장 모니터링',
    overview: '공장 사출 현황',
    machineOverview: '사출기 현황',
    defectHistory: '불량 이력',
    realtimeShot: '실시간 샷 현황',
  },
  machine: {
    title: '사출기 모니터링',
    dashboard: '사출기 대시보드',
    equipmentBoard: '설비 현황판',
  },
  ai: {
    title: 'AI 분석',
    analysis: 'AI 분석',
    manage: 'AI 관리',
  },
  moduleb: {
    title: '모듈B 융합판정',
    sync: '샷-제품 동기화',
    features: '특징 추출·정합',
    fusion: '3종 가중 융합',
    judgment: '종합 불량 판정',
  },
  modulec: {
    title: '모듈C 자율 품질관리',
    recommend: '권고 생성·승인',
    safeguard: '세이프가드',
  },
  management: {
    title: '공장/설비관리',
    factoryList: '공장현황',
    factoryRegister: '공장등록',
    equipmentList: '설비현황',
    equipmentRegister: '설비등록',
  },
  user: {
    title: '회원관리',
    list: '회원현황',
    register: '회원등록',
    role: '권한관리',
    notice: '공지현황',
  },
  system: {
    title: '시스템 관리',
    general: '일반설정',
    monitoring: '모니터링 설정',
    alarm: '알림설정',
    dataCollection: '데이터 수집관리',
    log: '시스템로그',
    ip: 'IP관리',
    labeling: '비전 라벨링',
  },
  platform: {
    title: '플랫폼 관리',
    companies: '회사 관리',
    users: '전체 사용자',
    status: '시스템 현황',
    licenses: '라이선스 관리',
  },
};

export default sidebar;
